import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { ProduccionForm } from "./components/ProduccionForm";
import "./styles/EdicionProduccion.css";

class EdicionProduccion extends Component {
    state = {
        idProduccion: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idProduccion = match.params.id;
        this.setState({ idProduccion });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Editar Producción"
                    subtitulo=""
                    col="12"
                >
                    <ProduccionForm
                        idProduccion={this.state.idProduccion}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(EdicionProduccion);
